export const CSS_LENGTH_UNITS = ["px", "em", "rem", "vh", "vw"];
export const cssNumber = /^-?\d*\.?\d+$/;
export const cssLength = new RegExp(`^-?\\d*\\.?\\d+(${CSS_LENGTH_UNITS.join("|")})$`);
export const cssPercentage = /^-?\d*\.?\d+%$/;
export const borderRegex = /^\d+(px|em|rem|%)?\s+(solid|dashed|dotted|double|groove|ridge|inset|outset)\s+([A-Za-z]+|#[\dA-Fa-f]{6}|#[\dA-Fa-f]{3})$/;
export const AUTO = "auto";
export var TEXT_TRANSFORM = /* @__PURE__ */ ((TEXT_TRANSFORM2) => {
  TEXT_TRANSFORM2["CAPITALIZE"] = "capitalize";
  TEXT_TRANSFORM2["UPPERCASE"] = "uppercase";
  TEXT_TRANSFORM2["LOWERCASE"] = "lowercase";
  TEXT_TRANSFORM2["NONE"] = "none";
  return TEXT_TRANSFORM2;
})(TEXT_TRANSFORM || {});
export var FONT_WEIGHT = /* @__PURE__ */ ((FONT_WEIGHT2) => {
  FONT_WEIGHT2["_100"] = "100";
  FONT_WEIGHT2["_200"] = "200";
  FONT_WEIGHT2["_300"] = "300";
  FONT_WEIGHT2["_400"] = "400";
  FONT_WEIGHT2["_500"] = "500";
  FONT_WEIGHT2["_600"] = "600";
  FONT_WEIGHT2["_700"] = "700";
  FONT_WEIGHT2["_800"] = "800";
  FONT_WEIGHT2["_900"] = "900";
  FONT_WEIGHT2["NORMAL"] = "normal";
  FONT_WEIGHT2["BOLD"] = "bold";
  return FONT_WEIGHT2;
})(FONT_WEIGHT || {});
export var DISPLAY = /* @__PURE__ */ ((DISPLAY2) => {
  DISPLAY2["BLOCK"] = "block";
  DISPLAY2["INLINE"] = "inline";
  DISPLAY2["INLINE_BLOCK"] = "inline-block";
  DISPLAY2["FLEX"] = "flex";
  DISPLAY2["NONE"] = "none";
  return DISPLAY2;
})(DISPLAY || {});
export var FLEX_DIRECTION = /* @__PURE__ */ ((FLEX_DIRECTION2) => {
  FLEX_DIRECTION2["ROW"] = "row";
  FLEX_DIRECTION2["COLUMN"] = "column";
  FLEX_DIRECTION2["ROW_REVERSE"] = "row-reverse";
  FLEX_DIRECTION2["COLUMN_REVERSE"] = "column-reverse";
  return FLEX_DIRECTION2;
})(FLEX_DIRECTION || {});
export var JUSTIFY_CONTENT = /* @__PURE__ */ ((JUSTIFY_CONTENT2) => {
  JUSTIFY_CONTENT2["START"] = "flex-start";
  JUSTIFY_CONTENT2["END"] = "flex-end";
  JUSTIFY_CONTENT2["CENTER"] = "center";
  JUSTIFY_CONTENT2["BETWEEN"] = "space-between";
  JUSTIFY_CONTENT2["AROUND"] = "space-around";
  JUSTIFY_CONTENT2["EVENLY"] = "space-evenly";
  return JUSTIFY_CONTENT2;
})(JUSTIFY_CONTENT || {});
export var ALIGN_ITEMS = /* @__PURE__ */ ((ALIGN_ITEMS2) => {
  ALIGN_ITEMS2["START"] = "flex-start";
  ALIGN_ITEMS2["END"] = "flex-end";
  ALIGN_ITEMS2["CENTER"] = "center";
  ALIGN_ITEMS2["BASELINE"] = "baseline";
  ALIGN_ITEMS2["STRETCH"] = "stretch";
  return ALIGN_ITEMS2;
})(ALIGN_ITEMS || {});
export var TEXT_ALIGN = /* @__PURE__ */ ((TEXT_ALIGN2) => {
  TEXT_ALIGN2["LEFT"] = "left";
  TEXT_ALIGN2["CENTER"] = "center";
  TEXT_ALIGN2["RIGHT"] = "right";
  TEXT_ALIGN2["JUSTIFY"] = "justify";
  return TEXT_ALIGN2;
})(TEXT_ALIGN || {});
export var POSITION = /* @__PURE__ */ ((POSITION2) => {
  POSITION2["STATIC"] = "static";
  POSITION2["RELATIVE"] = "relative";
  POSITION2["ABSOLUTE"] = "absolute";
  POSITION2["FIXED"] = "fixed";
  POSITION2["STICKY"] = "sticky";
  return POSITION2;
})(POSITION || {});
export var OBJECT_FIT = /* @__PURE__ */ ((OBJECT_FIT2) => {
  OBJECT_FIT2["CONTAIN"] = "contain";
  OBJECT_FIT2["COVER"] = "cover";
  OBJECT_FIT2["FILL"] = "fill";
  OBJECT_FIT2["NONE"] = "none";
  OBJECT_FIT2["SCALE_DOWN"] = "scale-down";
  return OBJECT_FIT2;
})(OBJECT_FIT || {});
